import {Job, JobCategoryTypes, Skill} from "@betrue/shared/interfaces";
import {SKILLS} from "./skills.dataset";
import {randomData} from "./helpers.dataset";
import {findByType} from "./jobs-categories.dataset";

export const JOBS = [{
  label: 'Developpeur full-stack',
  category: findByType(JobCategoryTypes.WEB_GRAPHIC_DESIGN),
  baseSkills: randomData<Skill>(SKILLS, 10)
},
  {
    label: 'Directeur de création',
    category: findByType(JobCategoryTypes.PROJECT_MANAGER_AGILE),
    baseSkills: randomData<Skill>(SKILLS, 10)
  },
  {
    label: 'Web Designer',
    category: findByType(JobCategoryTypes.BUSINESS_CONSULTING),
    baseSkills: randomData<Skill>(SKILLS, 10)
  },
  {
    label: 'Motion designer',
    category: findByType(JobCategoryTypes.BUSINESS_CONSULTING),
    baseSkills: randomData<Skill>(SKILLS, 10)
  }
] as Job[]
